import { types, Instance } from 'mobx-state-tree';

export const Filters = types.model('Filters', {
  office: types.array(types.string),
  team: types.array(types.array(types.union(types.string, types.number))),
  employment_type: types.array(types.string),
  experiences: types.array(types.string),
  job_function: types.array(types.string),
  activeFilters: types.frozen({})
});

export type IFilters = Instance<typeof Filters>;
